/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskFeedbackStyleEnum } from './taskFeedbackStyleEnum';

/**
 * Settings for generating feedback on a task submission
defined for each task
 */
export interface TaskFeedbackSettings {
  style: TaskFeedbackStyleEnum;
}
